<br />
<div class="banners">
  <div style="font-weight: 600; color: rgb(139, 139, 139); font-size: 1rem">Adicionar</div>
  <div class="form">
    <input type="file" (change)="selectFile($event)" />
    <br />
    <button (click)="sendFile()" class="btn-primary">Salvar</button>
  </div>
  <br />
  <div style="font-weight: 600; color: rgb(139, 139, 139)">Banners</div>
  <div cdkDropList (cdkDropListDropped)="drop($event)" id="listBanner">
    <div *ngFor="let banner of banners; let i = index" class="banner" cdkDrag>
      <mat-icon [ariaSetSize]="20"><span class="material-symbols-outlined"> drag_handle </span></mat-icon>
      <h1>{{ banner.id }}</h1>
      <img [src]="env.endPointApi + 'banner/' + banner.file_name" />
      <div class="remove">
        <mat-icon (click)="remove(banner.file_name)" style="color: rgb(255, 255, 255)">delete</mat-icon>
      </div>
    </div>
    <button (click)="saveOrder()" class="btn-primary">Salvar</button>
  </div>
</div>
